export default __webpack_public_path__ + "28520bfe37e388f592468185732c9621.svg";